// ** React Imports
import { useState, useEffect } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import {
  Grid,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Divider,
  Modal,
  InputLabel,
  Paper,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ReactSelect from "react-select";
import { Controller, useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SendIcon from "@mui/icons-material/Send";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SearchIcon from "@mui/icons-material/Search";
import DentistUse from "../DentistUse";
import OSAPAGE from "../Osapage";
import Letter from "../Letter";
import PatientsQuestionaire from "../PatientsQuestionaire";
import ConsentForm from "./ConsentForm";
import LetterForm from "./LetterForm";
import DentistForm from "./DentistForm";
import LetterOfNecessityForm from "./LetterOfNecessityForm";
import AffidavitForm from "./AffidavitForm";
import CancelIcon from "@mui/icons-material/Cancel";
import TMDQUESTIONNAIRE from "./TMDQUESTIONNAIRE";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ProviderExamForm = (props) => {
  const [isLoading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    minHeight: "5px !important",
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "&.MuiDataGrid-root .custom-column-header .MuiDataGrid-colCellTitle": {
      lineHeight: "20px !important",
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
    },
  };

  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };

  const [refresh, setRefresh] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [FormId, setFormId] = useState(0);
  const [rowId, setrowId] = useState(0);
  const [createdDate, setcreatedDate] = useState("");
  const [patientView, setpatientView] = useState("");
  const [completed, setcompleted] = useState("");
  const [createdBy, setcreatedBy] = useState("");
  const [selectedFormOpen, setSelectedFormOpen] = useState("");

  const handleFormClick = (formName) => {
    setSelectedFormOpen(formName);
    setOpenModal(true);
  };

  const handleClose = () => {
    setSelectedFormOpen("");
    setOpenModal(false);
    setsendToPortal(false);
  };

  const PatientId = props.patientId;
  const PatientINFO = props.Patientinfo;

  const renderFormContent = () => {
    switch (selectedFormOpen) {
      case "SCREENER":
        return (
          <LetterForm
            FormPatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientName={props.PatientName}
            onFormSubmit={(id) => {
              setFormId(id);
              if (id) {
                handleSingleFormSave(id, "SCREENER");
              }
            }}
          />
        );
      case "DENTISTS":
        return (
          <DentistForm
            FormPatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientName={props.PatientName}
            onFormSubmit={(id) => {
              setFormId(id);
              if (id) {
                handleSingleFormSave(id, "DENTISTS");
              }
            }}
          />
        );
      case "LOMN":
        return (
          <LetterOfNecessityForm
            PatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientDob={PatientINFO?.dob}
            PatientName={props.PatientName}
            onFormSubmit={(id) => {
              setFormId(id);
              if (id) {
                handleSingleFormSave(id, "LOMN");
              }
            }}
          />
        );
      case "QUESTIONNAIRES":
        return (
          <PatientsQuestionaire
            patientId={PatientId}
            Patientinfo={props.Patientinfo}
            OtherPatientInfo={props.OtherPatientInfo}
            handleClose={handleClose}
            callingFrom="ProviderNotes"
            FormId={FormId}
            onFormSubmit={(data) => {
              setFormId(data);
              if (data) {
                handleSingleFormSave(data, "QUESTIONNAIRES");
              }
            }}
          />
        );
      case "INFORMED_CONSENT":
        return (
          <ConsentForm
            PatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientName={props.PatientName}
            onFormSubmit={(data) => {
              setFormId(data.id);
              if (data.id) {
                handleSingleFormSave(data.id, "INFORMED_CONSENT");
              }
            }}
          />
        );
      case "AFFIDAVIT_CPAP_DEVICE":
        return (
          <AffidavitForm
            PatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientDob={PatientINFO?.dob}
            PatientName={props.PatientName}
            onFormSubmit={(data) => {
              setFormId(data);
              if (data) {
                handleSingleFormSave(data, "AFFIDAVIT_CPAP_DEVICE");
              }
            }}
          />
        );
      case "TMD-TMJ-PATIENT-QUESTIONNAIRE":
        return (
          <TMDQUESTIONNAIRE
            PatientId={PatientId}
            FormId={FormId}
            handleClose={handleClose}
            PatientDob={PatientINFO?.dob}
            PatientName={props.PatientName}
            onFormSubmit={(data) => {
              setFormId(data);
              if (data) {
                handleSingleFormSave(data, "TMD-TMJ-PATIENT-QUESTIONNAIRE");
              }
            }}
          />
        );
      default:
        return <div>No Page Found</div>;
    }
  };

  const renderInlineNewForm = (formName) => {
    const noop = () => {};

    switch (formName) {
      case "SCREENER":
        return (
          <LetterForm
            FormPatientId={PatientId}
            FormId={0}
            handleClose={noop}
            PatientName={props.PatientName}
            onFormSubmit={noop}
          />
        );
      case "DENTISTS":
        return (
          <DentistForm
            FormPatientId={PatientId}
            FormId={0}
            handleClose={noop}
            PatientName={props.PatientName}
            onFormSubmit={noop}
          />
        );
      case "LOMN":
        return (
          <LetterOfNecessityForm
            PatientId={PatientId}
            FormId={0}
            handleClose={noop}
            PatientDob={PatientINFO?.dob}
            PatientName={props.PatientName}
            onFormSubmit={noop}
          />
        );
      case "QUESTIONNAIRES":
        return (
          <PatientsQuestionaire
            patientId={PatientId}
            Patientinfo={props.Patientinfo}
            OtherPatientInfo={props.OtherPatientInfo}
            handleClose={noop}
            callingFrom="ProviderNotes"
            FormId={0}
            onFormSubmit={noop}
          />
        );
      case "INFORMED_CONSENT":
        return (
          <ConsentForm
            PatientId={PatientId}
            FormId={0}
            handleClose={noop}
            PatientName={props.PatientName}
            onFormSubmit={noop}
          />
        );
      case "AFFIDAVIT_CPAP_DEVICE":
        return (
          <AffidavitForm
            PatientId={PatientId}
            FormId={0}
            handleClose={noop}
            PatientDob={PatientINFO?.dob}
            PatientName={props.PatientName}
            onFormSubmit={noop}
          />
        );
      case "TMD-TMJ-PATIENT-QUESTIONNAIRE":
        return (
          <TMDQUESTIONNAIRE
            PatientId={PatientId}
            FormId={0}
            handleClose={noop}
            PatientDob={PatientINFO?.dob}
            PatientName={props.PatientName}
            onFormSubmit={noop}
          />
        );
      default:
        return <Typography>No Page Found</Typography>;
    }
  };

  const handleSingleFormSave = async (formId, formName) => {
    const postData = {
      id: rowId,
      patientName: props.PatientName,
      patientId: PatientId,
      sentToPortal: sendToPortal,
      formName: formName,
      formId: formId,
      type: "ProviderNotes",
      inActive: false,
      ...(createdDate
        ? { createdDate: createdDate, createdBy: createdBy }
        : {}),
      ...(patientView ? { patientView: patientView } : { patientView: false }),
      ...(completed ? { completed: completed } : {}),
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/PatientForms/AddForm`,
        postData,
        { headers },
      );

      handleClose();

      Swal.fire({
        icon: "success",
        title: "Form Added!",
        timer: 1500,
        showConfirmButton: false,
      });

      setRefresh((prev) => !prev);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
    }
  };

  const [selectedForm, setSelectedForm] = useState([]);
  const [sendToPortal, setsendToPortal] = useState(false);
  const [expandedForms, setExpandedForms] = useState([]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    {
      field: "formName",
      headerName: "Form Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      renderCell: (cellValues) => (
        <Button
          onClick={() => {
            handleFormClick(cellValues.row.formName);
            setrowId(cellValues.row.id);
            setSelectedForm([cellValues.row.formName]);
            setFormId(cellValues.row.formId ?? 0);
            setcreatedDate(cellValues.row.createdDate);
            setcreatedBy(cellValues.row.createdBy);
            setsendToPortal(cellValues.row.sentToPortal);
            setpatientView(cellValues.row.patientView);
            setcompleted(cellValues.row.completed);
          }}
          style={{ display: "flex", justifyContent: "flex-start" }}
          size="small"
          variant="text"
          color="info"
        >{`${cellValues.row.formName}`}</Button>
      ),
    },
    {
      field: "patientName",
      headerName: "PatientName",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
      renderCell: (params) =>
        params.value ? moment(params.value).format("MM/DD/YYYY") : "",
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
      renderCell: (cell) => (
        <DeleteIcon
          style={{
            marginRight: "3px",
            float: "right",
            marginTop: "5px",
            color: "red",
            marginleft: "4px",
          }}
          color="black"
          onClick={() => {
            Swal.fire({
              title: "Are you sure?",
              text: "Do you want to delete the record?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              confirmButtonColor: "#d33",
              cancelButtonColor: "#6c7c84",
              heightAuto: false,
              backdrop: true,
              didOpen: () => {
                const popup = document.querySelector(".swal2-popup");
                const container = document.querySelector(".swal2-container");
                const backdrop = document.querySelector(".swal2-backdrop");

                if (popup) popup.style.zIndex = "1801";
                if (container) container.style.zIndex = "1801";
                if (backdrop) backdrop.style.zIndex = "1800";
              },
            }).then((result) => {
              if (result.isConfirmed) {
                const postData = {
                  id: cell.row.id,
                  inActive: true,
                  patientView: cell.row.patientView,
                };

                axios
                  .post(
                    `${process.env.REACT_APP_API_URL}/PatientForms/AddForm`,
                    postData,
                    { headers },
                  )
                  .then(() => {
                    setRefresh(!refresh);

                    Swal.fire({
                      title: "Deleted!",
                      text: "Record deleted successfully.",
                      icon: "success",
                      showConfirmButton: false,
                      timer: 1200,
                      heightAuto: false,
                    });
                  })
                  .catch((error) => {
                    console.error("There was an error!", error);

                    Swal.fire({
                      title: "Error!",
                      text: "Something went wrong.",
                      icon: "error",
                      heightAuto: false,
                    });
                  });
              }
            });
          }}
        />
      ),
    },
  ];

  const [rows, setRows] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/PatientForms/GetFormByPatientId?patientId=${PatientId}&type=${"ProviderNotes"}`,
        { headers },
      )
      .then((response) => {
        setLoading(false);
        setRows(response);
      })
      .catch((error) => {});
  }, [refresh, PatientId]);

  const [OpenNewForm, setOpenNewForm] = useState(false);

  const handleOpenNewForm = () => {
    setOpenNewForm(true);
    setrowId(0);
  };

  const handleCloseNewForm = () => {
    setOpenNewForm(false);
    setSelectedForm([]);
    setsendToPortal(false);
    setFormId(0);
    setSelectedFormOpen("");
    setExpandedForms([]);
  };

  const [searchText, setSearchText] = useState("");

  const formOptions = [
    // { label: "QUESTIONNAIRES", value: "QUESTIONNAIRES" },
    // { label: "SCREENER", value: "SCREENER" },
    { label: "LOMN", value: "LOMN" },
    { label: "DENTISTS", value: "DENTISTS" },
    // { label: "INFORMED CONSENT", value: "INFORMED_CONSENT" },
    // {
    //   label: "AFFIDAVIT FOR INTOLERANCE TO CPAP DEVICE",
    //   value: "AFFIDAVIT_CPAP_DEVICE",
    // },
    // {
    //   label: "TMD-TMJ-PATIENT-QUESTIONNAIRE",
    //   value: "TMD-TMJ-PATIENT-QUESTIONNAIRE",
    // },
  ];

  const filteredOptions = formOptions.filter((option) =>
    option.label.toLowerCase().includes(searchText.toLowerCase()),
  );

  const toggleExpanded = (formName) => {
    setExpandedForms((prev) =>
      prev.includes(formName)
        ? prev.filter((x) => x !== formName)
        : [...prev, formName],
    );
  };

  const handleCheckboxClick = (value) => {
    setSelectedForm((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
    setExpandedForms((prev) =>
      prev.includes(value) ? prev : [...prev, value],
    );
  };

  // =============================================
  // UPDATED: handleSave now also sends email
  // =============================================
  const handleSave = async () => {
    if (selectedForm.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Form Selected",
        text: "Please select at least one form",
      });
      return;
    }

    try {
      // Step 1: Add all selected forms to portal
      await Promise.all(
        selectedForm.map((formName) => {
          const postData = {
            id: rowId,
            patientName: props.PatientName,
            patientId: PatientId,
            sentToPortal: sendToPortal,
            formName: formName,
            type: "ProviderNotes",
            formId: 0,
            inActive: false,
            ...(createdDate
              ? { createdDate: createdDate, createdBy: createdBy }
              : {}),
            ...(patientView
              ? { patientView: patientView }
              : { patientView: false }),
            ...(completed ? { completed: completed } : {}),
          };

          return axios.post(
            `${process.env.REACT_APP_API_URL}/PatientForms/AddForm`,
            postData,
            { headers },
          );
        }),
      );

      // Step 2: Send email notification after forms are added
      let emailSuccess = true;
      let emailMessage = "";

      // Step 3: Reset state
      setSelectedForm([]);
      handleCloseNewForm();

      // Step 4: Show appropriate success/warning message
      if (emailSuccess) {
        Swal.fire({
          icon: "success",
          title: "Forms Added!",
          html: `
            <p>All selected forms have been added successfully.</p>
            <p>A notification email has been sent to the patient.</p>
          `,
          timer: 2500,
          showConfirmButton: false,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Forms Added!",
          html: `
            <p>All selected forms have been added successfully.</p>
            <p style="color: #f44336;">However, email notification failed: ${emailMessage}</p>
          `,
          confirmButtonColor: "#FFA500",
        });
      }

      setRefresh((prev) => !prev);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        html: `<p>${
          error.response?.data?.message ||
          "Something went wrong. Please try again."
        }</p>`,
        confirmButtonColor: "#F44336",
      });
    }
  };

  return (
    <Container>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "1800" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "54%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "89%", sm: "70%", md: "75%" },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            maxHeight: "84vh",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            sx={{
              backgroundColor: "#E9F5EF",
              borderRadius: "12px",
              padding: "0.6rem 1rem",
              boxShadow: "0 2px 4px rgba(55,117,98,0.25)",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "#00695C",
                letterSpacing: "0.5px",
                fontSize: { xs: "1rem", sm: "1.1rem" },
              }}
            >
              {selectedFormOpen}
            </Typography>

            <IconButton
              onClick={handleClose}
              sx={{
                color: "#00695C",
                backgroundColor: "#C6F3DD",
                transition: "0.3s",
                "&:hover": {
                  backgroundColor: "#00695C",
                  color: "#FFFFFF",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={1}>
            {renderFormContent()}
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={OpenNewForm}
        onClose={handleCloseNewForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "1800" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "54%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "85%", sm: "70%", md: "60%" },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            maxHeight: "84vh",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            sx={{
              backgroundColor: "#E9F5EF",
              borderRadius: "12px",
              padding: "0.6rem 1rem",
              boxShadow: "0 2px 4px rgba(55,117,98,0.25)",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "#00695C",
                letterSpacing: "0.5px",
                fontSize: { xs: "1rem", sm: "1.1rem" },
              }}
            >
              Add New Form
            </Typography>

            <IconButton
              onClick={handleCloseNewForm}
              sx={{
                color: "#00695C",
                backgroundColor: "#C6F3DD",
                transition: "0.3s",
                "&:hover": {
                  backgroundColor: "#00695C",
                  color: "#FFFFFF",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Grid container spacing={1}>
            {/* Patient Name */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Patient Name
              </Typography>
              <Paper
                elevation={1}
                sx={{
                  padding: 1.5,
                  backgroundColor: "#f5f5f5",
                  borderRadius: 1,
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#333",
                }}
              >
                {props.PatientName || "N/A"}
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Forms
              </Typography>
              <FormControl component="fieldset" fullWidth>
                <Grid item xs={12} container justifyContent="center">
                  <TextField
                    placeholder="SEARCH FORMS..."
                    variant="outlined"
                    size="small"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "#377562", fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      width: { xs: "90%", sm: "70%", md: "50%" },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "25px",
                        backgroundColor: "#F9FCFB",
                        transition: "0.3s ease",
                        "& fieldset": {
                          borderColor: "#9BC7B0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#377562",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#00695C",
                          boxShadow: "0 0 6px rgba(55,117,98,0.3)",
                        },
                      },
                      "& input": {
                        fontSize: "0.9rem",
                        padding: "8px 10px",
                        textTransform: "uppercase",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#6b6b6b",
                        opacity: 0.8,
                        textTransform: "uppercase",
                      },
                    }}
                  />
                </Grid>

                {filteredOptions.map((option) => (
                  <Accordion
                    key={option.value}
                    expanded={expandedForms.includes(option.value)}
                    onChange={() => toggleExpanded(option.value)}
                    sx={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "10px",
                      mb: 1,
                      "&:before": { display: "none" },
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <FormControlLabel
                        onClick={(e) => e.stopPropagation()}
                        onFocus={(e) => e.stopPropagation()}
                        control={
                          <Checkbox
                            size="small"
                            checked={selectedForm.includes(option.value)}
                            onClick={() => handleCheckboxClick(option.value)}
                          />
                        }
                        label={option.label}
                      />
                    </AccordionSummary>

                    <AccordionDetails>
                      <Box
                        sx={{
                          pointerEvents: "none",
                          "& button": { display: "none !important" },
                          "& .MuiButton-root": {
                            display: "none !important",
                          },
                        }}
                      >
                        <Grid container spacing={1}>
                          {renderInlineNewForm(option.value)}
                        </Grid>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </FormControl>
            </Grid>

            {/* Buttons */}
            <Grid item xs={12} container spacing={2} justifyContent="flex-end">
              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  style={{
                    height: "40px",
                    fontSize: "14px",
                    color: "white",
                  }}
                  onClick={handleSave}
                >
                  Add To Notes
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  style={{
                    height: "40px",
                    fontSize: "14px",
                    color: "white",
                  }}
                  onClick={handleCloseNewForm}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Grid container>
        <Grid item xs={12}>
          <Button
            sx={{ mb: 1 }}
            className="Button"
            variant="contained"
            onClick={handleOpenNewForm}
          >
            <AddOutlinedIcon
              fontSize="small"
              style={{
                color: "white",
                paddingRight: "4px",
                paddingBottom: "2px",
                float: "right",
              }}
            />
            Choose Provider Templates
          </Button>
        </Grid>
      </Grid>

      <Box mb={3} marginTop={2}>
        {isLoading ? (
          <div style={{ margin: "5rem", textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <div style={{ height: 400, width: "100%" }}>
            {rows === null || rows.length === 0 ? (
              <Typography>No Record found</Typography>
            ) : (
              <DataGrid
                rows={rows}
                columns={columns}
                // getRowHeight={() => "auto"}
                sx={{
                  ...gridRowStyle,
                  "& .MuiDataGrid-cell": {
                    alignItems: "center",
                    whiteSpace: "normal",
                    lineHeight: 1.2,
                    py: 1,
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    whiteSpace: "normal",
                    lineHeight: 1.2,
                  },
                }}
              />
            )}
          </div>
        )}
      </Box>
    </Container>
  );
};

export default ProviderExamForm;
